import React from 'react';
import RMModal from 'components/modal/RMModal';
import { LoadingModal, ModalProps } from '.';
import { ModalType } from './constants';

function Modal(props: ModalProps) {
  const { type } = props;
  if (type === ModalType.Loading) {
    return <LoadingModal {...props} />;
  } else if (type === ModalType.Alert) {
    return <RMModal {...props} />;
  }
}

export default Modal;
